<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-apps</v-icon>{{$t('profile.software.versions')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <SoftwareVersionForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import SoftwareVersionForm from '../../components/softwareversion/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'SoftwareVersion';

const { mapFields } = createHelpers({
  getterType: 'softwareversion/getField',
  mutationType: 'softwareversion/updateField'
});

export default {
  name: 'SoftwareVersionCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    SoftwareVersionForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('softwareversion', ['create', 'reset'])
  }
};
</script>
